import { createFileRoute } from '@tanstack/react-router'

import { routeOptions, TrialSignUpPage } from '@/modules/auth'

export const Route = createFileRoute('/trial')({
  ...routeOptions,
  staticData: { title: 'Start your free trial' },
  component: TrialSignUpPage,
})
